import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute, PublicOnlyRoute } from './ProtectedRoute';
import AnalyticsWrapper from '../components/common/AnalyticsWrapper';
import { GoogleOAuthProvider } from '@react-oauth/google';

// Home
import Home from '../components/home/Home';

import ChatsContainer from '../components/chats/ChatsContainer';
import StoreContainer from '../components/store/StoreContainer';
import SettingsContainer from '../components/settings/SettingsContainer';
import SubscriptionContainer from '../components/subscription/SubscriptionContainer';
import OAuthCallback from '../pages/OAuthCallback';

// Admin Route
import AdminRoute from './AdminRoute';
import AdminContainer from '../components/admin/AdminContainer';

// Agents
import AgentsContainer from '../components/agents/AgentsContainer';
import AgentDetailsContainer from '../components/agents/AgentDetailsContainer';
import AgentChatContainer from '../components/agents/chats/AgentChatContainer';

// Legal Pages
import TermsOfService from '../pages/TermsOfService';
import PrivacyPolicy from '../pages/PrivacyPolicy';

// Auth
import Register from '../components/auth/Register';
import VerifyEmail from '../components/auth/VerifyEmail';
import Login from '../components/auth/Login';
import Waitlist from '../components/auth/Waitlist'; // WAITLIST_PHASE

const AppRoutes = () => {
  return (
    <Routes>
      {/* Home page with analytics */}
      <Route path="/" element={
        <AnalyticsWrapper><Home /></AnalyticsWrapper>
      } />

      {/* Public Only Routes */}
      <Route element={<PublicOnlyRoute />}>
        <Route path="/login" element={
          <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
            <Login />
          </GoogleOAuthProvider>
        } />
        <Route path="/register" element={
          <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
            <Register />
          </GoogleOAuthProvider>
        } />
        <Route path="/waitlist" element={<Waitlist />} />
      </Route>

      {/* Public Routes */}
      <Route path="/verify/:token" element={<VerifyEmail />} />
      <Route path="/terms" element={
        <AnalyticsWrapper><TermsOfService /></AnalyticsWrapper>
      } />
      <Route path="/privacy" element={
        <AnalyticsWrapper><PrivacyPolicy /></AnalyticsWrapper>
      } />

      {/* Public Agent Chat Routes (guest-friendly) */}
      <Route path="/agent/:agentSlug" element={<AgentChatContainer />} />
      <Route path="/a/:chatId" element={<AgentChatContainer />} />

      {/* Protected Routes */}
      <Route element={<ProtectedRoute />}>
        {/* Chats */}
        <Route path="/chats" element={<ChatsContainer />} />
        <Route path="/c/:chatId" element={<ChatsContainer />} />
        {/* Store */}
        <Route path="/store/*" element={<StoreContainer />} />

        {/* Agents - For Managing Agents */}
        <Route path="/agents" element={<AgentsContainer />} />
        <Route path="/agents/:slug" element={<AgentDetailsContainer />} />
        <Route path="/agents/:slug/settings" element={<AgentDetailsContainer />} />

        {/* Settings */}
        <Route path="/settings/*" element={<SettingsContainer />} />
        {/* Subscription */}
        <Route path="/subscription" element={<SubscriptionContainer />} />
        {/* Admin */}
        <Route element={<AdminRoute />}> 
          <Route path="/admin/*" element={<AdminContainer />} />
        </Route>
        {/* OAuth */}
        <Route path="/services/oauth/callback" element={<OAuthCallback />} />
      </Route>

      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default AppRoutes;
